import PropTypes from 'prop-types';
import prepareTranslate from '@/helpers/dictionary';
import docsMutation from '@/api/mutitations/docs';
import { useState, useEffect } from 'react';
import Table from '../Table';
import { extractFilterOptions, filterAndSortData } from '../Table/Table.functions';

const AgentCommisions = (props) => {
  const { agent, id } = props;
  const t = prepareTranslate();
  const { mutateAsync: tableMutateAsync } = docsMutation.useExportTable();
  const { mutateAsync: exportFileMutate } = docsMutation.useExportFile();

  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [filterOptions, setFilterOptions] = useState({});
  const [columnFilters, setColumnFilters] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (data.length && columns.length) {
      const options = extractFilterOptions(data, columns);
      setFilterOptions(options);
    }
  }, [data, columns]);

  useEffect(() => {
    if (columns.length) {
      const initialFilters = columns
        .filter((col) => col.accessor)
        .reduce((acc, col) => {
          acc[col.accessor] = '';
          return acc;
        }, {});
      setColumnFilters(initialFilters);
    }
  }, [columns]);

  const filterLocalData = (query, sort) => filterAndSortData(data, query, sort);

  const fetchDataFromServer = async (query) => {
    setIsLoading(true);

    const queryData = {
      identifiers: [id],
      exportRuleId: '68739f4fac56150cb8b56222',
      additionalData: {
        companyId: [],
        productId: [],
      },
      query: query || {},
      year: [],
      month: [],
    };

    try {
      const { data: mutateData } = await tableMutateAsync(queryData);
      const { rows, columns: dataColumns } = mutateData;

      // eslint-disable-next-line no-unused-vars
      const cleanColumns = dataColumns.map(({ filter, ...rest }) => rest);
      setColumns(cleanColumns);
      setData(rows);

      return { data: rows, count: rows.length };
    } catch (error) {
      return { data: [], count: 0 };
    } finally {
      setIsLoading(false);
    }
  };

  const getData = async (start, end, query, sort) => {
    if (data.length === 0) {
      const result = await fetchDataFromServer(query);
      return result;
    }
    const filteredData = filterLocalData(query, sort);
    return {
      data: filteredData,
      count: filteredData.length,
    };
  };

  useEffect(() => {
    const loadInitialData = async () => {
      await fetchDataFromServer({});
    };

    loadInitialData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // eslint-disable-next-line consistent-return
  const createFile = async (option, query) => {
    const requestColumns = columns.filter((column) => column.title !== 'פעולות');
    const exportData = {
      query: { ...query, _id: id },
      fileType: option,
      columns: requestColumns,
      titleArray: [''],
      data,
    };

    const fileTitleBase = t('components.agentCommisions.fileTitle', [agent.personalDetails.fullName]);
    const fileTitle = option === 'pdf' ? `${fileTitleBase}.pdf` : `${fileTitleBase}.xlsx`;

    try {
      const fileData = await exportFileMutate(exportData);
      return { fileData, fileTitle };
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Error fetching additionalFees:', error);
    }
  };

  return (
      <Table
        getData={getData}
        columns={columns}
        isColumnsActive={false}
        columnFilters={columnFilters}
        setColumnFilters={setColumnFilters}
        filterOptions={filterOptions}
        exportOptions={['excel']}
        isLoading={isLoading}
        createFile={createFile}
      />
  );
};

AgentCommisions.propTypes = {
  agent: PropTypes.object,
  id: PropTypes.string,
};
export default AgentCommisions;
